<template>
  <div class="data-release">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>数据发布(Data release)</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :model="searchParams" class="search-form" :inline="true">
        <el-divider></el-divider>
        <el-form-item  label="数据类别">
          <el-select  size="mini" v-model="searchParams.currenttable" style="width:200px;" 
                      filterable placeholder="Proposal/GRB/SEM" clearable @change="setdatalevel">
                  <el-option
                      v-for="item in filedataltype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label="数据级别">
          <el-select  size="mini" v-model="searchParams.level" style="width:200px;" filterable placeholder="1L/1.5L/2L..." clearable>
                  <el-option
                      v-for="item in datalevel"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <el-form  class="search-form" :inline="true">
        <el-form-item :label="`${$t('noLoginApplyDialog.ogs_id')}:`">
          <el-autocomplete
          class="inline-input"
            :placeholder="`${$t('noLoginApplyDialog.ogs_id')}`"
            style="width: 220px"
            v-model="searchParams.obs_id"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            @select="handleSelect"
            clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item :label="`${$t('DataRelease.filepath')}:`">
          <el-input style="width: 672px"  v-model="searchParams.file_path"></el-input>
        </el-form-item> 
        <el-divider content-position="left">原版信息</el-divider>
        <el-form-item :label="`${$t('DataRelease.fileid')}:`">
          <el-input style="width: 200px"  v-model="searchParams.fileID" :disabled="true"></el-input>
        </el-form-item> 
        <el-form-item :label="`${$t('DataRelease.filesign')}:`">
          <el-input style="width: 200px"  v-model="searchParams.file_sign" :disabled="true"></el-input>
        </el-form-item> 
        <el-form-item :label="`${$t('DataRelease.filever')}:`">
          <el-input style="width: 200px"  v-model="searchParams.file_ver" :disabled="true"></el-input>
        </el-form-item>        
        <el-form-item :label="`${$t('DataRelease.ver')}:`">
          <el-input style="width: 180px" v-model="searchParams.ver"  :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('DataRelease.filelength')}:`">
          <el-input style="width: 150px" v-model="searchParams.file_length" :disabled="true"></el-input>
        </el-form-item>
        <el-divider content-position="left" v-if="isupdate">新版信息</el-divider>
        <el-form-item :label="`${$t('DataRelease.filever')}:`" v-if="isupdate"> 
          <el-input style="width: 200px"  v-model="searchParams.newfile_ver" :disabled="true" v-if="isupdate"></el-input>
        </el-form-item>        
        <el-form-item :label="`${$t('DataRelease.ver')}:`" v-if="isupdate">
          <el-input style="width: 180px" v-model="searchParams.newver"  :disabled="true" v-if="isupdate"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('DataRelease.filelength')}:`" v-if="isupdate">
          <el-input style="width: 150px" v-model="searchParams.newfile_length" :disabled="true" v-if="isupdate"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <!-- <el-form-item label="是否公开">
          <el-checkbox size='mini' v-model="checkedisopen"></el-checkbox>
        </el-form-item> -->
      </el-form>
      <el-form class="search-form" :inline="true" align="center">
        <el-form-item>
          <el-button size='max' @click="checkfile">{{$t('DataRelease.check')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='max' type="primary" @click="onSubmit" :disabled="ablerelease">{{$t('DataRelease.release')}}</el-button>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
import {filedatatable,PropDataLevel,SemDataLevel} from '../common';
import axios from 'axios';

export default {
  name: 'DataRelease',
  data() {
    return {
      searchParams: {
        currenttable:'',
        level:'',
        obs_id:'',
        file_path:'',
        file_sign:'',
        file_ver:'',
        ver:'',
        fileID:'',
        file_length:'',
        newfile_ver:'',
        newver:'',
        newfile_length:'',
      },
      list: [],
      restaurants: [],
      filedataltype: filedatatable,
      datalevel:'',
      filesize:0,
      fileinfo:null,
      ablerelease:true,
      isupdate:false,
    };
  },
  created() {
    // this.getData();
    // this.getobsiddata();
  },
  methods: {


    onSubmit() {
      if(this.isupdate)
      {
        this.fileupdate();
        this.ablerelease = true;
        this.isupdate = false;
      }else{

        this.filerelease();
        this.ablerelease = true;
      }
    },
    filerelease(){
      const params = {
        ...this.searchParams,
      };
      axios.post('/iapi/Fileinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('发布文件数据成功！');
        }
      });
    },
    fileupdate(){
      const params = {
        ...this.searchParams,
      };
      axios.post('/iapi/Fileupdate', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新版本文件数据更新成功！');
        }
      });
    },

    setdatalevel(val){
      if(val==='OBS'){
        this.datalevel =  PropDataLevel;
        this.getobsiddata();
      }else if(val==='SEM'){
        this.datalevel =  SemDataLevel;
        this.getsemiddata();
      }else if(val==='GRB'){
        this.datalevel =  SemDataLevel;
        this.getgrbiddata();
      }
    },

    getobsiddata(){
      const params = {

      }
      axios.post('/iapi/getobslist',params).then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
          // console.log('target-list',this.restaurants );
        }
      });
    },
    getsemiddata(){
      const params = {
        
      }
      axios.post('/iapi/getsemlist',params).then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
          // console.log('target-list',this.restaurants );
        }
      });
    },
    getgrbiddata(){
      const params = {

      }
      axios.post('/iapi/getgrblist',params).then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
          // console.log('target-list',this.restaurants );
        }
      });
    },
    setfileid(val){
      if(val){
        this.searchParams.fileID = val.file_id;
        this.searchParams.file_sign = val.file_sign;
        this.searchParams.file_ver = val.file_ver;
        this.searchParams.file_path = val.file_path;
        this.searchParams.ver = val.ver;
        this.searchParams.file_length = val.file_length;
      }
    },

    getfielinfo(val){
      const params = {
        type: this.searchParams.currenttable,
        obs_id: val,
        level:this.searchParams.level,
      }
      axios.post('/iapi/getfileinfo',params).then((res) => {
        if (res.data.errcode === 0) {
          // this.fileinfo = res.data.data;
          // console.log('fileinfo',this.fileinfo );
          this.setfileid(res.data.data);
        }else{
          this.$message('未发现相关ID数据！');
        }
      });

      
      // console.log('fileID',this.searchParams.fileID);
    },

    querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
    },
    handleSelect(item) {
        if(item){
          this.searchParams.fileID = '';
          this.searchParams.file_path = '';
          this.getfielinfo(item.value);
        }
    },
    createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
        };
    },
    //检查文件路径是否存在,如果存在且继续,发布数据,生成新的ver(原有ver+1)
    checkfile(){
      if(this.searchParams.file_path){
        try{
          var filename = ((this.searchParams.file_path.split(/(\\|\/)/g).pop()).split('.'))[0].split('_');
          var tempfilever = filename[3].substr(3,1).concat(filename[4]).concat(filename[5]);
          var tempfilesign = filename[0].concat(filename[1]).concat(filename[2]);
        }catch(err){
          alert('请检查输入的文件路径及文件名是否符合规范! \n(例如: /data/HXMT_P0214064008_L1_Ver1_10_20200612.taz)');
          return;
        }

        const params = {
          file_path: this.searchParams.file_path,
          file_sign: tempfilesign,
          file_ver: tempfilever,
        }
        
        axios.post('/iapi/CheckFile',params).then((res) => {
          if (res.data.errcode === 1) {
            if(confirm('发现相同的文件路径,是否继续?')){
              this.ablerelease = false;
              this.isupdate = true;
              this.filesize = res.data.filesize;
              this.setnewfilepath(this.searchParams.file_path);
            }                
          }else if(res.data.errcode === 2){
            this.ablerelease = false;
            this.filesize = res.data.filesize;
            this.setfilepath(this.searchParams.file_path);
            this.$message('数据正常,请点击发布按钮!');
          }else if(res.data.errcode === 3){
            alert('数据文件不存在,请检查!');
          }else if(res.data.errcode === 4){
            alert('数据文件未更新,请检查!');
          }
        });

      }
    },
    setfilepath(val){
      if(val){
        var filename = ((val.split(/(\\|\/)/g).pop()).split('.'))[0].split('_');
        this.searchParams.file_sign = filename[0].concat(filename[1]).concat(filename[2]);
        this.searchParams.file_ver = filename[3].substr(3,1).concat(filename[4]).concat(filename[5]);
        this.searchParams.ver = 0;
        this.searchParams.file_length = this.filesize;
      }
    },
    setnewfilepath(val){
      if(val){
        var filename = ((val.split(/(\\|\/)/g).pop()).split('.'))[0].split('_');
        this.searchParams.newfile_ver = filename[3].substr(3,1).concat(filename[4]).concat(filename[5]);
        this.searchParams.newver = this.searchParams.ver+1 ;
        this.searchParams.newfile_length = this.filesize;
      }
    },
  },
};
</script>

<style scoped>
.data-release {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 10px;
    margin-bottom: 10px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>